import React from 'react';
import {
  Container,
  Header,
  Segment,
  Icon,
  Image,
  Item,
  Divider,
  Button,
  Grid
} from 'semantic-ui-react';
import DivWrapper from './DivWrapper';

import {FormattedMessage, injectIntl} from 'react-intl';

import maxPic from '../img/team/profile_max.png';
import paulinePic from '../img/team/profile_pauline.png';
import martinPic from '../img/team/profile_martin.png';
import josephPic from '../img/team/profile_joseph.png';
import marcelPic from '../img/team/profile_marcel.png';
import inesPic from '../img/team/profile_ines.png';

import audoryIcon from '../img/audory-icon-button.png';
import rosemaxIcon from '../img/rosemax-icon-button.png';
import teamImage from '../img/testTeam.gif';

import EXISTComponent from './EXISTComponent';
import PartnersComponent from './PartnersComponent';
import RecordingStudiosComponent from './RecordingStudiosComponent';
import { PRIMARY_COLOR } from '../constants';



const PageHeader = ({mobile}) => (
    <Segment 
        inverted
        textAlign='center'
        style={{ padding: '0em 0em' }}
        vertical
      >
        <Container text style={{padding: '5em 0em'}}>
            <Header
                as='h1'
                inverted
                style={{
                fontSize: mobile ? '2em' : '4em',
                fontWeight: 'normal',
                marginBottom: 0,
                }}
            >
                <FormattedMessage id="audory.responsiveContainer.body.team"/>
            </Header>
            <Header
                as='h2'
                inverted
                style={{
                fontSize: mobile ? '1.5em' : '1.7em',
                fontWeight: 'normal',
                }}
            >
                <FormattedMessage id="audory.teampage.header.text"/>
            </Header>
        
        </Container>
        
    </Segment>
)

const TeamPage = ({ intl }) => {
    return (
        <DivWrapper>
        <PageHeader />
        <Segment style={{ padding: '4em 0em', margin: 0 }}>
            <Container text>

                <Header as='h3' style={{ fontSize: '2em', textAlign: 'justify' }}>
                    <FormattedMessage id="audory.teampage.body.header"/>
                </Header>
                <p style={{ fontSize: '1.33em', textAlign: 'justify' }}>
                    <FormattedMessage id="audory.teampage.body.text"/>
                </p>
<center><Image src={'https://ik.imagekit.io/vidory/vidory-static/title_home.jpg?tr=w-1000,h-400,fo-custom,q-90'} rounded /></center>
                
            </Container>

            <Divider horizontal style={{margin: '4em 0em 2em 0em'}}>
                <Header as='h3'>
                    <Icon name='group' />
                    Team
                </Header>
            </Divider>

            <Container text>
                <Item.Group>
                    <Item>
                        <Item.Image size='medium' circular src={maxPic} />

                        <Item.Content>
                            <Item.Header>Max Rose</Item.Header>
                            <Item.Meta>
                                <FormattedMessage id="audory.teampage.max.position"/>
                                <br/>
                                <div style={{marginTop: '0.5em'}}>
                                E-Mail: <a style={{color: PRIMARY_COLOR}} href='mailto:max.rose@audory.de'>max.rose@audory.de</a>
                                </div>
                                
                            </Item.Meta>
                            <Item.Description>
                                <p style={{textAlign: 'justify'}}>
                                    <FormattedMessage id="audory.teampage.max.description"/>
                                </p>
                            </Item.Description>
                            <Item.Extra>
                                <Grid columns={4}>
                                    <Grid.Column align='center'>
                                        <Segment as='a' href='https://rosemax.de' target='_blank' circular style={{padding: 10}}>
                                            <Image style={{width: 30}} src={rosemaxIcon} />
                                        </Segment>
                                    </Grid.Column>
                                    <Grid.Column align='center'>
                                        <Button as='a' size='huge' href='https://www.xing.com/profile/Max_Rose23' target='_blank' basic circular icon='xing' />
                                    </Grid.Column>
                                    <Grid.Column align='center'>
                                        <Button as='a' size='huge' href='https://www.linkedin.com/in/rose-max/' target='_blank' basic circular icon='linkedin' />
                                    </Grid.Column>
                                    <Grid.Column align='center'>
                                        <Button as='a' size='huge' href='mailto:max.rose@audory.de' basic circular icon='mail' />
                                    </Grid.Column>
                                </Grid>
                            </Item.Extra>
                        </Item.Content>
                    </Item>

                    <Item>
                        <Item.Image size='medium' circular src={'https://ik.imagekit.io/vidory/vidory-static/tr:h-600,w-600,r-max/konstantin_scheicher_1.jpg'} />

                        <Item.Content>
                            <Item.Header>Konstantin Scheicher</Item.Header>
                            <Item.Meta>
                            Marketer & Vertriebler


                                <br/>
                                <div style={{marginTop: '0.5em'}}>
                                E-Mail: <a style={{color: PRIMARY_COLOR}} href='mailto:konstantin.scheicher@vidory.de'>konstantin.scheicher@vidory.de</a>
                                </div>
                                
                            </Item.Meta>
                            <Item.Description>
                                <p style={{textAlign: 'justify'}}>
                                Konstantin studiert derzeit Global Communication in Business and Culture in Mittweida. Als leidenschaftlicher Marketer bringt er frische Ideen in unser Team ein. Sein Gespür für Trends und seine kreative Herangehensweise machen ihn zu einem Experten in der Entwicklung zielgerichteter Vertriebsstrategien. Konstantin ist überzeugt, dass erfolgreicher Vertrieb auf Partnerschaft und maßgeschneiderten Lösungen basiert.
                                </p>
                            </Item.Description>
                            <Item.Extra>
                                <Grid columns={4}>
                                <Grid.Column align='center'>
                                        <Button as='a' size='huge' href='https://vidory.de/watch/649c4236b83193570b90553f' target='_blank' basic circular icon='play' />
                                    </Grid.Column>
                                    <Grid.Column align='center'>
                                        <Button as='a' size='huge' href='https://www.xing.com/profile/Konstantin_scheicher' target='_blank' basic circular icon='xing' />
                                    </Grid.Column>
                                    <Grid.Column align='center'>
                                        <Button as='a' size='huge' href='https://www.linkedin.com/in/konstantin-scheicher-b27826257' target='_blank' basic circular icon='linkedin' />
                                    </Grid.Column>
                                    <Grid.Column align='center'>
                                        <Button as='a' size='huge' href='mailto:konstantin.scheicher@vidory.de' basic circular icon='mail' />
                                    </Grid.Column>
                                </Grid>
                            </Item.Extra>
                        </Item.Content>
                    </Item>

                    <Item>
                        <Item.Image size='medium' circular src={'https://ik.imagekit.io/vidory/vidory-static/tr:h-600,w-600,r-max/fabian_schrode_1.jpg'} />

                        <Item.Content>
                            <Item.Header>Fabian Schrode</Item.Header>
                            <Item.Meta>
                            Storyteller


                                <br/>
                                <div style={{marginTop: '0.5em'}}>
                                E-Mail: <a style={{color: PRIMARY_COLOR}} href='mailto:fabian.schrode@vidory.de'>fabian.schrode@vidory.de</a>
                                </div>
                                
                            </Item.Meta>
                            <Item.Description>
                                <p style={{textAlign: 'justify'}}>
                                Fabian studiert derzeit Medieninformatik u. Interaktives Entertainment in Mittweida. Sein Fokus liegt auf dem Schreiben interaktiver Geschichten, die die Fantasie anregen. Mit einem Hintergrund in kreativem Schreiben gestaltet er einzigartige narrative Erlebnisse. Fabian liebt es, Grenzen zu durchbrechen und durch seine Geschichten emotionale Verbindungen zu schaffen. Sein Ziel ist es, durch interaktive Erzählungen Menschen zu fesseln und unvergessliche Erlebnisse zu schaffen.
                                </p>
                            </Item.Description>
                            <Item.Extra>
                                <Grid columns={4}>
                                <Grid.Column align='center'>
                                        <Button as='a' size='huge' href='https://vidory.de/watch/649c3f51491eaad343e911ea' target='_blank' basic circular icon='play' />
                                    </Grid.Column>
                                    
                                    <Grid.Column align='center'>
                                        <Button as='a' size='huge' href='mailto:fabian.schrode@vidory.de' basic circular icon='mail' />
                                    </Grid.Column>
                                </Grid>
                            </Item.Extra>
                        </Item.Content>
                    </Item>

{
    /*
<Item>
                        <Item.Image size='medium' circular src={paulinePic} />

                        <Item.Content>
                            <Item.Header>Pauline Schneider</Item.Header>
                            <Item.Meta>
                                <FormattedMessage id="audory.teampage.pauline.position"/>
                                <br/>
                                <div style={{marginTop: '0.5em'}}>
                                E-Mail: <a style={{color: PRIMARY_COLOR}} href='mailto:pauline.schneider@audory.de'>pauline.schneider@audory.de</a>
                                </div>
                            </Item.Meta>
                            <Item.Description>
                                <p style={{textAlign: 'justify'}}>
                                    <FormattedMessage id="audory.teampage.pauline.description"/>
                                </p>
                            </Item.Description>
                            <Item.Extra>
                                <Grid columns={3}>
                                    <Grid.Column align='center'>
                                        <Segment as='a' href='/user/pauline.schneider' target='_blank' circular style={{padding: 10}}>
                                            <Image style={{width: 30}} src={audoryIcon} />
                                        </Segment>
                                    </Grid.Column>
                                    <Grid.Column align='center'>
                                        <Button as='a' size='huge' href='https://www.xing.com/profile/Pauline_Schneider19' target='_blank' basic circular icon='xing' />
                                    </Grid.Column>
                                    {/*
                                    <Grid.Column align='center'>
                                        <Button as='a' size='huge' basic circular icon='linkedin' />
                                    </Grid.Column>
                                    
                                    <Grid.Column align='center'>
                                        <Button as='a' size='huge' href='mailto:pauline.schneider@audory.de' basic circular icon='mail' />
                                    </Grid.Column>
                                </Grid>
                            </Item.Extra>
                        </Item.Content>
                    </Item>
    */
}
                    

                    
                </Item.Group>
            </Container>
            
            <Divider horizontal style={{margin: '4em 0em 2em 0em'}}>
                <Header as='h3'>
                    <Icon name='graduation cap' />
                    {intl.formatMessage({id: "audory.teampage.mentors"})}
                </Header>
            </Divider>

            <Container text>
                <Item.Group>
                    <Item>
                        <Item.Image size='medium' circular src={martinPic} />
                        <Item.Content>
                            <Item.Header>Prof. Dr.-Ing. Martin Gaedke</Item.Header>
                            <Item.Meta>
                                <FormattedMessage id="audory.teampage.martin.position"/>
                            </Item.Meta>
                            <Item.Description>
                                <p style={{textAlign: 'justify'}}>
                                    <FormattedMessage id="audory.teampage.martin.description"/>
                                </p>
                            </Item.Description>
                            <Item.Extra>
                                <Grid columns={3}>
                                    <Grid.Column align='center'>
                                        <Button as='a' size='huge' href='https://vsr.informatik.tu-chemnitz.de/' target='_blank' basic circular icon='university' />
                                    </Grid.Column>
                                    <Grid.Column align='center'>
                                        <Button as='a' size='huge' href='https://www.xing.com/profile/Martin_Gaedke' target='_blank' basic circular icon='xing' />
                                    </Grid.Column>
                                    <Grid.Column align='center'>
                                        <Button as='a' size='huge' href='https://www.linkedin.com/in/gaedke/' target='_blank' basic circular icon='linkedin' />
                                    </Grid.Column>
                                </Grid>
                            </Item.Extra>
                        </Item.Content>
                    </Item>

                    <Item>
                        <Item.Image size='medium' circular src={josephPic} />
                        <Item.Content>
                            <Item.Header>Dr. Joseph Heß</Item.Header>
                            <Item.Meta>
                                <FormattedMessage id="audory.teampage.joseph.position"/>
                            </Item.Meta>
                            <Item.Description>
                                <p style={{textAlign: 'justify'}}>
                                    <FormattedMessage id="audory.teampage.joseph.description"/>
                                </p>
                            </Item.Description>
                            <Item.Extra>
                                <Grid columns={3}>
                                    <Grid.Column align='center'>
                                        <Button as='a' size='huge' href='https://www.rheinschwimmer.de/' target='_blank' basic circular icon='globe' />
                                    </Grid.Column>
                                    <Grid.Column align='center'>
                                        <Button as='a' size='huge' href='https://www.xing.com/profile/Joseph_Hess6' target='_blank' basic circular icon='xing' />
                                    </Grid.Column>
                                    <Grid.Column align='center'>
                                        <Button as='a' size='huge' href='https://www.linkedin.com/in/joseph-heß-7531b31a5' target='_blank' basic circular icon='linkedin' />
                                    </Grid.Column>
                                </Grid>
                            </Item.Extra>
                        </Item.Content>
                    </Item>

                </Item.Group>

            </Container>

            <Divider horizontal style={{margin: '4em 0em 2em 0em'}}>
                <Header as='h3'>
                    <Icon name='microphone' />
                    {intl.formatMessage({id: "audory.teampage.studios"})}
                </Header>
            </Divider>

            <Container text>
                <Item.Group>
                    <Item>
                        <Item.Image size='medium' circular src={inesPic} />
                        <Item.Content>
                            <Item.Header>Ines Zimzinski</Item.Header>
                            <Item.Meta>
                                <FormattedMessage id="audory.teampage.ines.position"/>
                            </Item.Meta>
                            <Item.Description>
                                <p style={{textAlign: 'justify'}}>
                                    <FormattedMessage id="audory.teampage.ines.description"/>
                                </p>
                            </Item.Description>
                            <Item.Extra>
                                <Grid columns={2}>
                                    <Grid.Column align='center'>
                                        <Button as='a' size='huge' href='https://www.diehoeragenten.de/' target='_blank' basic circular icon='globe' />
                                    </Grid.Column>
                                    <Grid.Column align='center'>
                                        <Button as='a' size='huge' href='https://www.instagram.com/diehoeragenten/' target='_blank' basic circular icon='instagram' />
                                    </Grid.Column>
                                </Grid>
                            </Item.Extra>
                        </Item.Content>
                    </Item>

                    <Item>
                        <Item.Image size='medium' circular src={marcelPic} />
                        <Item.Content>
                            <Item.Header>Marcel Hallensleben</Item.Header>
                            <Item.Meta>
                                <FormattedMessage id="audory.teampage.marcel.position"/>
                            </Item.Meta>
                            <Item.Description>
                                <p style={{textAlign: 'justify'}}>
                                    <FormattedMessage id="audory.teampage.marcel.description"/>
                                </p>
                            </Item.Description>
                            <Item.Extra>
                                <Grid columns={3}>
                                    <Grid.Column align='center'>
                                        <Button as='a' size='huge' href='https://www.soundsquirrel.de/' target='_blank' basic circular icon='globe' />
                                    </Grid.Column>
                                    <Grid.Column align='center'>
                                        <Button as='a' size='huge' href='https://www.xing.com/profile/Marcel_Hallensleben' target='_blank' basic circular icon='xing' />
                                    </Grid.Column>
                                    <Grid.Column align='center'>
                                        <Button as='a' size='huge' href='https://www.linkedin.com/in/marcel-hallensleben/' target='_blank' basic circular icon='linkedin' />
                                    </Grid.Column>
                                </Grid>
                            </Item.Extra>
                        </Item.Content>
                    </Item>

                </Item.Group>

            </Container>

            <Divider horizontal style={{margin: '4em 0em 2em 0em'}}>
                <Header as='h3'>
                    <Icon name='handshake' />
                    {intl.formatMessage({id: "audory.teampage.supporters"})}
                </Header>
            </Divider>

            {/*<EXISTComponent />*/}
            {/*<RecordingStudiosComponent />*/}
            <PartnersComponent />

        </Segment>
    </DivWrapper>
    );
};

export default injectIntl(TeamPage);


// WEBPACK FOOTER //
// ./src/components/TeamPage.js